import { render, staticRenderFns } from "./KanbanAttributes.vue?vue&type=template&id=1cb902be&scoped=true&"
import script from "./KanbanAttributes.vue?vue&type=script&lang=js&"
export * from "./KanbanAttributes.vue?vue&type=script&lang=js&"
import style0 from "./KanbanAttributes.vue?vue&type=style&index=0&id=1cb902be&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cb902be",
  null
  
)

export default component.exports